module.exports = __webpack_public_path__ + "fb6c111bc6767a138819190a0def2c13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/tanner.jpg
// module id = 202
// module chunks = 0